import * as uploadFns from './upload'

export const uploadHelpers = { ...uploadFns }
